export const CustomEventDescriptions = {
  name: "Display name shown in the Events Manager and when selecting metrics for an experience.",
  description: "Internal note explaining what this event tracks.",
  applyToUrls:
    "Optional URL rules restricting which pages this event fires on. Omit to track on all pages. For 'equals', 'doesNotEqual', 'startsWith', and 'doesNotStartWith' match types, `value` must not start with a '/'.",
  type: "Determines which visitor behavior is tracked and which `settings` shape is required. Use pageView for any page visit, productPageView/collectionPageView for specific product or collection pages, clickEvent/elementViewed for CSS-selector-targeted DOM interactions, scrollDepth for scroll-percentage milestones, and javascriptEvent for a custom JS snippet that fires the event.",
} as const;

export const CustomEventClickEventSettingsDescriptions = {
  selectors:
    "CSS selectors identifying the elements whose clicks should be tracked.",
} as const;

export const CustomEventElementViewedSettingsDescriptions = {
  selectors:
    "CSS selectors identifying the elements whose visibility in the viewport should be tracked.",
} as const;

export const CustomEventScrollDepthSettingsDescriptions = {
  mobile: "Scroll depth threshold to track on mobile viewports.",
  desktop: "Scroll depth threshold to track on desktop viewports.",
  percentage:
    "Percentage of page height scrolled (0-100) that triggers the event.",
} as const;

export const CustomEventJavascriptSettingsDescriptions = {
  code: "JavaScript snippet injected into a <script> tag on the page. To register an occurrence, it must call `window.igEvents.push({ event: \"<identifier>\" })` where `<identifier>` exactly matches this event's own identifier. The identifier is server-generated and only returned after creation, so write a placeholder here and update the event's code afterward with the returned identifier.",
} as const;

export const CustomEventProductPageViewSettingsDescriptions = {
  productId: "Shopify product ID to track page views for.",
  handle: "Shopify product handle to track page views for.",
} as const;

export const CustomEventCollectionPageViewSettingsDescriptions = {
  handle: "Shopify collection handle to track page views for.",
} as const;
